import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

/** Coming-soon-mode public footer. No private links. */
export default function PublicFooter() {
  return (
    <footer className="border-t border-ivory-400 bg-ivory-100 mt-24" data-testid="public-footer">
      <div className="container-editorial py-16 grid md:grid-cols-4 gap-10 text-sm">
        <div>
          <div className="flex items-center gap-3">
            <Logo variant="master-black" height={40} />
          </div>
          <p className="text-ink-100 mt-6 leading-relaxed">
            A trusted marketplace for exceptional luxury motorhomes, professional touring coaches and purpose-built tour trailers.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Collections</div>
          <ul className="space-y-2 text-ink-50 text-xs">
            <li><Link to="/ultra-luxury-motorcoaches" className="hover:text-copper">Ultra-Luxury Motorcoaches</Link></li>
            <li><Link to="/touring-collection" className="hover:text-copper">Touring Collection</Link></li>
            <li><Link to="/premium-class-a" className="hover:text-copper">Premium Class A</Link></li>
            <li><Link to="/premium-super-c" className="hover:text-copper">Premium Super C</Link></li>
            <li><Link to="/overland-vehicles" className="hover:text-copper">Overland Vehicles</Link></li>
            <li><Link to="/overland-trailers" className="hover:text-copper">Overland Trailers</Link></li>
            <li><Link to="/specialty-trailers" className="hover:text-copper">Specialty Trailers</Link></li>
            <li><Link to="/european-collection" className="hover:text-copper">European Collection</Link></li>
            <li><Link to="/auctions-preview" className="hover:text-copper">Auctions</Link></li>
            <li className="pt-1 mt-2 border-t border-ivory-400"><Link to="/collections" className="text-copper hover:underline uppercase tracking-[0.18em] text-[10px]">Explore All Collections</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Platform</div>
          <ul className="space-y-2 text-ink-50">
            <li><Link to="/vanturis-trust" className="hover:text-copper">Vanturis Trust</Link></li>
            <li><Link to="/vanturis-standards" className="hover:text-copper">Vanturis Standards</Link></li>
            <li><Link to="/concierge-preview" className="hover:text-copper">Concierge</Link></li>
            <li><Link to="/about" className="hover:text-copper">About</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Get in Touch</div>
          <ul className="space-y-2 text-ink-50">
            <li><Link to="/marketplace" className="hover:text-copper" data-testid="footer-marketplace">Marketplace</Link></li>
            <li><Link to="/early-access" className="hover:text-copper">Early Access</Link></li>
            <li><Link to="/contact" className="hover:text-copper">Contact</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-copper" data-testid="footer-legal-privacy">Privacy Policy</Link></li>
            <li><Link to="/legal/terms" className="hover:text-copper" data-testid="footer-legal-terms">Terms of Use</Link></li>
            <li><Link to="/legal/listing-disclaimer" className="hover:text-copper" data-testid="footer-legal-disclaimer">Listing Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ivory-400 py-6 text-[10px] uppercase tracking-[0.22em] text-ink-100 text-center">
        © {new Date().getFullYear()} Vanturis · A New Standard in Luxury Motorcoach Commerce
      </div>
    </footer>
  );
}
